module.exports = __webpack_public_path__ + "img/a11.3d1a8868.png";